import { useContext } from 'react';

import { SemanticHeadingBaseLevel } from './SemanticHeading.types';
import SemanticHeadingBaseLevelContext from './SemanticHeadingBaseLevelContext';

export const useSemanticHeadingBaseLevelContext: () => SemanticHeadingBaseLevel = () =>
  useContext(SemanticHeadingBaseLevelContext);
